import {Dialog, Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import "dayjs/locale/es";
import Escoger_Fecha_Calendario_Cita from "../Componentes/Escoger_Fecha_Calendario_Cita";
import {Close} from '@mui/icons-material'
import {obtenerCol} from "../../Servicios/BD/obtenerCol";


export const useEscogerFechaCita = ({colecionDiasDispo = '', coleccionCita = '', fechaDefecto = ''}) => {
    const [diasDispo, setDiasDispo] = useState([])
    const [fecha, setFecha] = useState(fechaDefecto)
    const [open, setOpen] = useState(false)
    dayjs.locale('es')

    const cerrar = () => {
        setOpen(false)
    }

    const Tarjeta_Cita = ({editable = true}) => {
        return (
            <>
                <Grid
                    onClick={() => {
                        if (editable) {
                            setOpen(true)
                        }
                    }}
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{border: 1, borderColor: theme.palette.primary.main, borderRadius: 2, p: 2, cursor: 'pointer'}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{color: '#00000090'}}>Fecha de reunion</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography
                            sx={{
                                fontSize: 30,
                                fontWeight: 800,
                                lineHeight: 1.1
                            }}>{fecha ? new dayjs(fecha).format('ddd DD MMMM h:mm a').toUpperCase() : 'Escoger fecha'}</Typography>
                    </Grid>

                </Grid>

                <Dialog open={open} maxWidth={'xs'} fullWidth

                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{overflowX: 'hidden'}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 2}}>
                            <IconButton
                                onClick={() => setOpen(false)}
                            ><Close/></IconButton>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -4}}>
                            <Escoger_Fecha_Calendario_Cita fecha={fecha} setFecha={setFecha} cerrar={cerrar}
                                                           diasDispo={diasDispo} coleccionCita={coleccionCita}/>
                        </Grid>


                    </Grid>

                </Dialog>

            </>

        )
    }


    useEffect(() => {

        if (open) {
            obtenerCol(colecionDiasDispo).then((dox) => {
                if (dox.res) {
                    setDiasDispo(dox.data)
                }
            })
        }

    }, [colecionDiasDispo, open]);
    return {

        Tarjeta_Cita,
        fecha
    }
}